import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-analysis-time" }
const _hoisted_2 = {
  key: 0,
  class: "actions"
}
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "infos" }
const _hoisted_5 = { class: "line" }
const _hoisted_6 = { class: "uppercase" }
const _hoisted_7 = { class: "line items-center" }
const _hoisted_8 = { class: "text-5" }
const _hoisted_9 = { class: "line" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "date-edit-value" }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "date-edit-value" }
const _hoisted_15 = {
  key: 0,
  class: "canceled"
}
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "breaks" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "items" }
const _hoisted_20 = { class: "infos" }
const _hoisted_21 = { class: "line" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "line" }
const _hoisted_24 = { class: "line" }
const _hoisted_25 = { class: "line" }
const _hoisted_26 = { class: "line" }
const _hoisted_27 = { class: "options" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "empty"
}
const _hoisted_30 = {
  key: 0,
  class: "actions"
}

import {
  onMounted,
  ref,
  computed,
  watch,
  onBeforeUnmount,
  watchEffect,
} from "vue";
import { onBeforeRouteLeave, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import moment from "moment";
import store from "@/store";

import {
  getDate,
  getHour,
  getDifference,
  getDiffBreaks,
} from "@/common/utils/dates";

import { toast } from "@/common/utils/toast";

import type { BreakType, BreakPayloadType } from "@/common/types/breaks";

import {
  analysisPatch,
  analysisStart,
  analysisCancel,
  // analysisPause,
  // analysisPauseUpdate,
  // analysisResume,
  analysisStop,
} from "@/common/api/rest/analysis/analysis";

import {
  analysisBreakList,
  analysisBreakCreate,
  analysisBreakPatch,
  analysisBreakStop,
} from "@/common/api/rest/analysis/break";

import {
  baseConfirm,
  baseModal,
  baseSelect,
  baseTextarea,
  svgIcon,
} from "@/common/components";

import { breakForm, dateEditForm } from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'card-analysis-time',
  props: {
    accountId: {},
    analysisId: {},
    status: {},
    startDate: {},
    startEdited: {},
    startEditedMotive: {},
    endDate: {},
    endEdited: {},
    endEditedMotive: {},
    breaks: {},
    canceledDescription: {}
  },
  emits: ["update", "update-description"],
  setup(__props: any, { emit: __emit }) {

const route = useRoute();

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const interval = ref();
const time = ref<string>("0m 0s");
const breakTime = ref<string>("0m 0s");

const description = ref<string>("");
const breakPayload = ref<BreakPayloadType | null>(null);
const breakSelected = ref<BreakType | null>(null);
const editDatePayload = ref<{
  date: string;
  hour: string;
  motive: string;
} | null>(null);

const editedDate = ref<string | null>(null);
const editedDateType = ref<"start" | "end" | null>(null);

const showModalStart = ref(false);
const showModalPause = ref(false);
const showModalResume = ref(false);
const showModalStop = ref(false);
const showModalCancel = ref(false);
const showModalEditDate = ref(false);

const enumAnalysisStatus = computed(
  () => tm("enums.analysis_status") as Record<string, string>,
);

const isEditDate = computed(() => {
  return store.getters.type === "ADMIN" || store.getters.type === "MANAGER";
});

function timeCount() {
  time.value = getDiffBreaks(
    (props.startEdited ?? props.startDate) as string,
    (props.endEdited ?? props.endDate) as string,
    props.breaks || [],
  ).text;
}

function dateDiff(start_date: string, end_date: string | null) {
  if (!start_date) return "0m 0s";

  const diff = getDifference(
    start_date,
    end_date ? end_date : new Date().toISOString(),
  );

  return diff.text;
}

function formatTime() {
  if (props.startDate && props.endDate) {
    timeCount();

    if (interval.value) {
      clearInterval(interval.value);
      interval.value = null;
    }
    return;
  }

  if (props.status === "PAUSED") {
    timeCount();

    if (!props.breaks) return;

    const breakIndex = props.breaks?.length - 1;
    const breakData = props.breaks[breakIndex];

    if (!breakData) return;

    interval.value = setInterval(() => {
      breakTime.value = dateDiff(breakData.start_date, breakData.end_date);
    }, 1000);
    return;
  }

  if (props.startDate && !props.endDate && !interval.value) {
    interval.value = setInterval(() => {
      timeCount();
    }, 1000);
  }
}

// START
function analyseStart() {
  showModalStart.value = true;
}

function analyseStartCancel() {
  showModalStart.value = false;
}

function analyseStartConfirm() {
  showModalStart.value = false;

  analysisStart(props.accountId, props.analysisId)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// STOP
function analyseStop() {
  showModalStop.value = true;
}

function analyseStopCancel() {
  showModalStop.value = false;
}

function analyseStopConfirm() {
  showModalStop.value = false;

  analysisStop(props.accountId, props.analysisId)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });

        clearInterval(interval.value);
        interval.value = null;

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// CANCEL
function analyseCancel() {
  showModalCancel.value = true;
}

function analyseCancelCancel() {
  showModalCancel.value = false;
}

function analyseCancelConfirm() {
  showModalCancel.value = false;

  analysisCancel(props.accountId, props.analysisId)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });

        clearInterval(interval.value);
        interval.value = null;

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// PAUSE
function analysePause() {
  showModalPause.value = true;
}

function analysePauseCancel() {
  breakSelected.value = null;
  breakPayload.value = null;
  showModalPause.value = false;
}

function analysePauseConfirm() {
  if (!breakPayload.value) {
    toast({ message: t("analysis.toast.error.require_fields"), type: "error" });
    return;
  }

  if (!breakPayload.value.motive) {
    toast({
      message: t("analysis.toast.error.required_motive"),
      type: "error",
    });
    return;
  }

  if (breakSelected.value) {
    editBreakConfirm();

    return;
  }

  analysisBreakCreate(props.accountId, {
    evaluation_id: route.params.evaluation,
    analysis_id: props.analysisId,
    motive: breakPayload.value.motive,
    description: breakPayload.value.description,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        analysePauseCancel();
        toast({ message: message, type: "success" });

        clearInterval(interval.value);
        interval.value = null;

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// PAUSE EDIT
function editBreak(data: BreakType) {
  breakSelected.value = { ...data };
  breakPayload.value = {
    motive: data.motive,
    description: data.description,
  };

  showModalPause.value = true;
}

function editBreakConfirm() {
  if (!breakSelected.value) return;

  analysisBreakPatch(
    props.accountId,
    breakSelected.value.break_id,
    breakPayload.value,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        analysePauseCancel();
        toast({ message: message, type: "success" });

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// DATE
function editDate(type: "start" | "end") {
  editedDateType.value = type;

  if (type === "start") {
    editDatePayload.value = {
      date: moment(props.startEdited || props.startDate).format("YYYY-MM-DD"),
      hour: moment(props.startEdited || props.startDate).format("HH:mm:ss"),
      motive: props.startEditedMotive ?? "",
    };

    showModalEditDate.value = true;
    return;
  }

  editDatePayload.value = {
    date: moment(props.endEdited || props.endDate).format("YYYY-MM-DD"),
    hour: moment(props.endEdited || props.endDate).format("HH:mm:ss"),
    motive: props.endEditedMotive ?? "",
  };

  showModalEditDate.value = true;
}

function editDateCancel() {
  editedDate.value = null;
  editedDateType.value = null;
  showModalEditDate.value = false;
}

function editDateConfirm() {
  if (
    !editDatePayload.value?.date ||
    !editDatePayload.value?.hour ||
    !editDatePayload.value?.motive
  ) {
    toast({ message: "Preencha todos os campos", type: "error" });
    return;
  }

  const payload = {
    [`${editedDateType.value}_edited`]: `${editDatePayload.value?.date} ${editDatePayload.value?.hour}`,
    [`${editedDateType.value}_edited_motive`]: editDatePayload.value?.motive,
  };

  analysisPatch(props.accountId, props.analysisId, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        editDateCancel();
        toast({ message: message, type: "success" });

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// RESUME
function analyseResume() {
  showModalResume.value = true;
}

function analyseResumeCancel() {
  showModalResume.value = false;
}

function analyseResumeConfirm() {
  if (!props.breaks) return;

  const breakIndex = props.breaks?.length - 1;
  const breakData = props.breaks[breakIndex];

  if (!breakData) return;

  analysisBreakStop(props.accountId, breakData.break_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });

        analyseResumeCancel();
        clearInterval(interval.value);
        interval.value = null;

        emit("update");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeDescription() {
  emit("update-description", description.value);
}

watch(
  () => props.startDate,
  () => {
    formatTime();
  },
);

watch(
  () => props.endDate,
  () => {
    formatTime();
  },
);

watch(
  () => props.breaks,
  () => {
    formatTime();
  },
);

watchEffect(() => {
  if (props.canceledDescription) {
    description.value = String(props.canceledDescription || "");
  }
});

onBeforeRouteLeave(() => {
  clearInterval(interval.value);
  interval.value = null;
});

onBeforeUnmount(() => {
  clearInterval(interval.value);
  interval.value = null;
});

onMounted(() => {
  formatTime();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (!props?.startDate && props.status !== 'CANCELED')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (analyseStart()))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "play",
                size: "1.5rem"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.play").toUpperCase()), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (analyseCancel()))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "close",
                size: "1.5rem"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.cancel").toUpperCase()), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!props?.endDate && props.status !== 'PAUSED')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-black",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (analyseStop()))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "pause",
                        size: "1.5rem"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.finish").toUpperCase()), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (analyseCancel()))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "close",
                        size: "1.5rem"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.cancel").toUpperCase()), 1)
                    ])
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "separate" }, null, -1))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.status")) + ":", 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(enumAnalysisStatus.value[props?.status]), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", null, _toDisplayString(_unref(t)("analysis.labels.elapsed_time")) + ":", 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(time.value), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", null, [
                  (props.startEdited)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.start")) + " ", 1),
                        _cache[25] || (_cache[25] = _createElementVNode("span", { style: {"color":"darkred"} }, " (editado) ", -1)),
                        _cache[26] || (_cache[26] = _createTextVNode(": ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.start")) + ": ", 1)
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getDate)(props.startEdited ?? props.startDate)) + " - " + _toDisplayString(_unref(getHour)(props.startEdited ?? props.startDate)), 1),
                  (props.startDate && props.endDate && isEditDate.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-default p-0 w-7 h-7",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (editDate('start')))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "edit",
                          size: "1.2rem"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", null, [
                  (props.endEdited)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.termination")) + " ", 1),
                        _cache[27] || (_cache[27] = _createElementVNode("span", { style: {"color":"darkred"} }, " (editado) ", -1)),
                        _cache[28] || (_cache[28] = _createTextVNode(": ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.termination")) + ": ", 1)
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getDate)(props.endEdited ?? props?.endDate)) + " - " + _toDisplayString(_unref(getHour)(props.endEdited ?? props?.endDate)), 1),
                  (props.startDate && props.endDate && isEditDate.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-default p-0 w-7 h-7",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (editDate('end')))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "edit",
                          size: "1.2rem"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (props.status === 'CANCELED')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("analysis.labels.cancellation_reason")) + ": ", 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_unref(baseTextarea), {
                        modelValue: description.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((description).value = $event)),
                        value: description.value,
                        placeholder: _unref(t)('common.placeholders.describe'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (changeDescription()))
                      }, null, 8, ["modelValue", "value", "placeholder"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "separate" }, null, -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)("analysis.labels.breaks")), 1),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.breaks, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.break_id,
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", null, _toDisplayString(_unref(t)("analysis.labels.elapsed_time")) + ": ", 1),
                        _createElementVNode("span", null, [
                          (item.status === 'PENDING')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(breakTime.value), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(dateDiff(item.start_date, item.end_date)), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.start")) + ": ", 1),
                        _createElementVNode("span", null, [
                          _createElementVNode("span", null, _toDisplayString(_unref(getDate)(item.start_date)) + " - " + _toDisplayString(_unref(getHour)(item.start_date)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.termination")) + ": ", 1),
                        _createElementVNode("span", null, [
                          _createElementVNode("span", null, _toDisplayString(_unref(getDate)(item.end_date)) + " - " + _toDisplayString(_unref(getHour)(item.end_date)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", null, _toDisplayString(_unref(t)("analysis.labels.motive")) + ": ", 1),
                        _createElementVNode("span", null, [
                          _createElementVNode("span", null, _toDisplayString(item.motive), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.description")) + ": ", 1),
                        _createElementVNode("span", null, [
                          _createElementVNode("span", null, _toDisplayString(item.description), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-default p-0 w-8 h-8",
                        onClick: ($event: any) => (editBreak(item))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "edit",
                          size: "1.25rem"
                        })
                      ], 8, _hoisted_28)
                    ])
                  ]))
                }), 128)),
                ((props.breaks?.length || 0) === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(t)("analysis.texts.empty_break")), 1))
                  : _createCommentVNode("", true)
              ]),
              (!props?.endDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (props.status !== 'PAUSED')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-black",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (analysePause()))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "pause",
                            size: "1.5rem"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("analysis.labels.add_pause").toUpperCase()), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (analyseResume()))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "play",
                            size: "1.5rem"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("analysis.labels.remove_pause").toUpperCase()), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalStart.value,
      "max-width": "400px",
      title: 
      _unref(t)('common.labels.play', {
        concat: _unref(t)('common.labels.analyse'),
      }).toUpperCase()
    ,
      message: _unref(t)('analysis.texts.start_analysis'),
      "text-align": "start",
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (analyseStartCancel())),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (analyseStartConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalResume.value,
      "max-width": "400px",
      title: _unref(t)('analysis.modal.title.resume').toUpperCase(),
      message: _unref(t)('analysis.modal.message.resume'),
      "text-align": "start",
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (analyseResumeCancel())),
      onConfirm: _cache[13] || (_cache[13] = ($event: any) => (analyseResumeConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalStop.value,
      "max-width": "400px",
      title: 
      _unref(t)('common.labels.finish', {
        concat: _unref(t)('common.labels.analyse'),
      }).toUpperCase()
    ,
      message: _unref(t)('analysis.texts.finish_analysis'),
      "text-align": "start",
      onCancel: _cache[14] || (_cache[14] = ($event: any) => (analyseStopCancel())),
      onConfirm: _cache[15] || (_cache[15] = ($event: any) => (analyseStopConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalCancel.value,
      "max-width": "400px",
      title: 
      _unref(t)('common.labels.cancel', {
        concat: _unref(t)('common.labels.analyse'),
      }).toUpperCase()
    ,
      message: _unref(t)('analysis.texts.cancel_analysis'),
      "text-align": "start",
      onCancel: _cache[16] || (_cache[16] = ($event: any) => (analyseCancelCancel())),
      onConfirm: _cache[17] || (_cache[17] = ($event: any) => (analyseCancelConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseModal), {
      show: showModalPause.value,
      title: _unref(t)('analysis.labels.add_pause').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": 
      breakSelected.value
        ? _unref(t)('common.labels.save')
        : _unref(t)('common.labels.add').toUpperCase()
    ,
      "button-close": _unref(t)('common.labels.cancel').toUpperCase(),
      onClose: _cache[19] || (_cache[19] = ($event: any) => (analysePauseCancel())),
      onConfirm: _cache[20] || (_cache[20] = ($event: any) => (analysePauseConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(breakForm), {
          data: breakPayload.value,
          onUpdateData: _cache[18] || (_cache[18] = ($event: any) => (breakPayload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseModal), {
      show: showModalEditDate.value,
      title: _unref(t)('analysis.labels.date_edit').toUpperCase(),
      "show-button-confirm": true,
      width: "50%",
      "button-confirm": _unref(t)('common.labels.save').toUpperCase(),
      "button-close": _unref(t)('common.labels.cancel').toUpperCase(),
      onClose: _cache[22] || (_cache[22] = ($event: any) => (editDateCancel())),
      onConfirm: _cache[23] || (_cache[23] = ($event: any) => (editDateConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(dateEditForm), {
          data: editDatePayload.value,
          onUpdateData: _cache[21] || (_cache[21] = ($event: any) => (editDatePayload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"])
  ], 64))
}
}

})